define('scrollblocker',["jquery"], function ($) {
    var shouldBlock = window.cordova && navigator.userAgent.match(/|iPhone|iPad|iPod/i) != null;

    return function(element) {
        var touchStartY = -1;
        var touchStartHandler = function (e) {
            touchStartY = e.targetTouches[0].clientY;
        };
        var bodyScrollLocker = function (e) {
            var moveAmount = event.targetTouches[0].clientY - touchStartY;

            if(moveAmount > 0 && element.scrollTop === 0) {
                if (e.preventDefault) e.preventDefault();
                return false;
            }

            if(moveAmount < 0 && element.scrollHeight - element.scrollTop <= element.clientHeight) {
                if (e.preventDefault) e.preventDefault();
                return false;
            }

            return true;
        };

        if(shouldBlock) {
            document.addEventListener("touchstart", touchStartHandler, {passive: false});
            document.addEventListener("touchmove", bodyScrollLocker, {passive: false});
        }
        
        this.unload = function () {
            if(shouldBlock) {
                document.removeEventListener("touchmove", bodyScrollLocker);
                document.removeEventListener("touchstart", touchStartHandler);
            }            
        }
    };
});
